// Reusable JSON-LD builders for SEO/AEO
const SITE = "https://acciongroup.com";

export const orgNode = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": `${SITE}/#organization`,
  name: "Accion Group",
  url: `${SITE}/`,
  logo: `${SITE}/accion-logo.png`,
  description:
    "Accion Group helps electric utilities and regulators design and run secure, transparent energy procurements, and operates PowerPro, a SOC 2 Type II certified RFP platform.",
};

export const breadcrumb = (
  items: { name: string; path: string }[],
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: `${SITE}${item.path}`,
  })),
});

export const faqPage = (qa: { q: string; a: string }[]) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: qa.map(({ q, a }) => ({
    "@type": "Question",
    name: q,
    acceptedAnswer: { "@type": "Answer", text: a },
  })),
});

export const softwareApp = (opts: {
  name: string;
  description: string;
  url: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "SoftwareApplication",
  name: opts.name,
  description: opts.description,
  url: opts.url,
  applicationCategory: "BusinessApplication",
  operatingSystem: "Web",
  provider: orgNode,
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "USD",
    availability: "https://schema.org/InStock",
    description:
      "Contact Accion Group for a personalized demo and pricing.",
  },
});

export const webSite = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  "@id": `${SITE}/#website`,
  url: `${SITE}/`,
  name: "Accion Group",
  publisher: orgNode,
  potentialAction: {
    "@type": "SearchAction",
    target: `${SITE}/?q={search_term_string}`,
    "query-input": "required name=search_term_string",
  },
});

export const SITE_ORIGIN = SITE;
